import React, { Fragment, useContext } from 'react';
import { Dialog, Transition } from '@headlessui/react';
// import { msalApp } from '../authConfig';
import { msalInstance } from '..';
import { APIContext } from '../contexts/APIContext';
import { getlogoutFlag, getValidToken } from '../utils';

export const SessionWarningModal = (props: any) => {
  const { sessionWarning, setSessionWarning, handleContinue } = props;
  const {
    websocketConnectionRef: { current: websocket },
    accounts,
    stopSignalRConnection,
  } = useContext(APIContext);
  const handleCloseSessionWarning = () => {
    setSessionWarning(false);
    handleContinue();
  };

  const handleEndSession = async () => {
    const token = await getValidToken();
    setSessionWarning(false);
    getlogoutFlag(websocket, accounts, token);
    await stopSignalRConnection();
    msalInstance.logoutRedirect();
  };

  return (
    <>
      {sessionWarning && (
        <>
          <Transition.Root show={sessionWarning} as={Fragment}>
            <Dialog as="div" className="relative z-[100]" onClose={() => setSessionWarning(true)}>
              {/* Opaque overlay */}
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black bg-opacity-70 transition-opacity" />
              </Transition.Child>

              {/* Modal panel */}
              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4"
                    enterTo="opacity-100 translate-y-0"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-4"
                  >
                    <div className="flex flex-col items-center flex-shrink-0 lg:w-1/2">
                      <Dialog.Panel className="relative flex border-t-4 border-t-[#A100FF] w-[582px] h-[320px] transform flex-col bg-gamma-modal-bg font-graphik text-black transition-all">
                        <div className="flex flex-row justify-end pr-[24px] pt-[28px]">
                          <img
                            src="/icons/Close.svg"
                            alt="Send suggested prompt"
                            className="w-[16px] h-[16px] cursor-pointer"
                            onClick={handleCloseSessionWarning}
                          />
                        </div>
                        <div className="relative flex transform flex-col gap-[24px] bg-[var(--Surface-card-bg, #FFF)] shadow-xl pt-[28px] pl-[40px]">
                          <Dialog.Title className="text-black font-graphik text-[28px] font-normal leading-[28px]">
                            Session Timeout
                          </Dialog.Title>
                          <Dialog.Description className="text-black font-graphik text-[14px] font-normal leading-[20px] pb-[51px]">
                            Your online session is about to end due to inactivity <br />
                            If you want to extend please click on Continue.
                          </Dialog.Description>
                        </div>

                        <div className="flex flex-row flex-nowrap justify-end gap-5 pr-[32px] pt-[24px]">
                          <button
                            className="rounded-sm border border-[#000] bg-[#FFFFFF] px-4 py-2 hover:bg-opacity-70"
                            onClick={handleEndSession}
                          >
                            End Session
                          </button>
                          <button
                            className="rounded-sm bg-[#000000] px-4 py-2 text-white hover:bg-opacity-70"
                            onClick={handleCloseSessionWarning}
                          >
                            Continue
                          </button>
                        </div>
                      </Dialog.Panel>
                    </div>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        </>
      )}
    </>
  );
};

export default SessionWarningModal;
